// What the berry board's saved banner hands on to Precool (F01 UF-12).
//
// After a plain "Receive delivery" the clerk's next step is a cooling batch
// for THAT delivery. Precool opens its new-batch form pre-picked from
// `?delivery=<id>` (the card's "N to cool →" link already uses it), so the
// banner's "Cool the crates →" carries the new id instead of landing on a bare
// board where the clerk re-finds the truck in the picker.
//
// After "Receive & put on dolly" the batch already exists (or is queued
// offline), so opening the new-batch form again would invite a second dolly
// for the same crates: the plain board is the right place then. A dolly that
// FAILED leaves the crates unbatched, so that case carries the id too.
//
// Pure so it unit-tests without mounting the page.

export interface BerryReceiveSaved {
  summary: string
  /** The delivery the save created; null if the insert returned no row. */
  deliveryId: string | null
  /** True when the same save also staged (or queued) a cooling batch. */
  dollyStaged: boolean
  /** The dolly's batch id when it reached the server (label page can open); null if queued or none. */
  dollyBatchId?: string | null
}

export function coolTheCratesHref(saved: BerryReceiveSaved): string {
  if (saved.dollyStaged || !saved.deliveryId) return '/precool'
  return `/precool?delivery=${encodeURIComponent(saved.deliveryId)}`
}

/** The footer's one filled button: the dolly save when it can run, else the plain receive. */
export function primaryReceiveAction(comboWeightReady: boolean): 'receive' | 'dolly' {
  return comboWeightReady ? 'dolly' : 'receive'
}

/** The dolly's label page, or null when there is none to open (no dolly, or it is queued offline). */
export function dollyLabelHref(saved: BerryReceiveSaved): string | null {
  return saved.dollyBatchId ? `/batch-label/${encodeURIComponent(saved.dollyBatchId)}` : null
}
